<template>
  <div>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Product
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-autocomplete
                ref="product_type"
                outlined
                v-model="form.product_type_id"
                :items="productTypeItems"
                label="Property Type *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.product_type_id"
              ></v-autocomplete>
            </v-col>
                        <v-col sm="4">
              <v-autocomplete
                ref="categories"
                outlined
                multiple
                v-model="form.category_ids"
                :items="categoryItems"
                label="Categories *"
                prepend-inner-icon="mdi-account-tie-outline"
                hide-details="auto"
                clearable
                :error-messages="errors.category_ids"
              />
            </v-col>

            <v-col sm="4">
              <v-text-field
                v-model="form.product_name"
                outlined
                label="Product Name *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.product_name"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.pre_tax_irr"
                outlined
                label="Pre Tax IRR"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.pre_tax_irr"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.minimum_invest"
                outlined
                label="Minimum Investment *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.minimum_invest"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.maximum_invest"
                outlined
                label="Maximum Investment *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.maximum_invest"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.end_tenure"
                outlined
                label="End Tenure *"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.end_tenure"
              />
            </v-col>
            <v-col sm="4">
              <v-autocomplete
                ref=""
                outlined
                v-model="form.risk_category"
                :items="riskCategoryItems"
                label="Risk Category"
                prepend-inner-icon="mdi-account-tie-outline"
                hide-details="auto"
                clearable
                :error-messages="errors.risk_category"
              />
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.amount_raised"
                outlined
                label="Amount Raised"
                prepend-inner-icon="mdi-buffet"
                hide-details="auto"
                :error-messages="errors.amount_raised"
              />
            </v-col>
            <v-col sm="4">
              <div class="text-caption grey--text text--darken-1 mb-1">
                Settlement / Payout Frequency
              </div>
              <v-btn-toggle
                v-model="form.payout_frequency"
                mandatory
                dense
                color="primary"
                class="d-flex"
              >
                <v-btn value="monthly" class="flex-grow-1" outlined>
                  <v-icon left small>mdi-calendar-month-outline</v-icon>
                  Monthly
                </v-btn>
                <v-btn value="yearly" class="flex-grow-1" outlined>
                  <v-icon left small>mdi-calendar-outline</v-icon>
                  Yearly
                </v-btn>
              </v-btn-toggle>
              <div v-if="errors.payout_frequency" class="v-messages error--text mt-1">
                {{ errors.payout_frequency }}
              </div>
            </v-col>

            <v-col sm="4">
              <v-menu
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.settlememt_date"
                    label="Settlement Date *"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    hide-details="auto"
                    :error-messages="errors.settlememt_date"
                  />
                </template>
                <v-date-picker
                  v-model="form.settlememt_date"
                  @input="menu = false"
                />
              </v-menu>
            </v-col>
            <v-col sm="12" class="mb-2">
              <div class="text-subtitle-2 mb-2 font-weight-medium">Cover Photos</div>
              <input type="file" ref="imagesInput" multiple accept="image/*" @change="onImagesChange" style="display:none" />
              <v-btn outlined color="primary" small @click="$refs.imagesInput.click()">
                <v-icon left small>mdi-image-plus</v-icon> Add Photos
              </v-btn>
              <div v-if="form.images && form.images.length" class="d-flex flex-wrap mt-3" style="gap:8px">
                <div v-for="(img, i) in form.images" :key="'exist-'+i" style="position:relative">
                  <img :src="mediaUrl + img" style="width:100px;height:80px;object-fit:cover;border-radius:8px;border:1px solid #ddd" />
                </div>
              </div>
              <div v-if="previewImages.length" class="d-flex flex-wrap mt-2" style="gap:8px">
                <div v-for="(img, i) in previewImages" :key="'new-'+i" style="position:relative">
                  <img :src="img" style="width:100px;height:80px;object-fit:cover;border-radius:8px;border:2px dashed #7c4dff" />
                  <v-btn icon x-small color="error" style="position:absolute;top:-8px;right:-8px" @click="removePreviewImage(i)">
                    <v-icon x-small>mdi-close-circle</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-col>

            <v-col sm="12" class="mb-2">
              <div class="text-subtitle-2 mb-2 font-weight-medium">Documents</div>
              <input type="file" ref="docsInput" multiple @change="onDocsChange" style="display:none" />
              <v-btn outlined color="secondary" small @click="$refs.docsInput.click()">
                <v-icon left small>mdi-file-plus</v-icon> Add Documents
              </v-btn>
              <!-- Existing documents -->
              <v-list dense v-if="form.documents && form.documents.length" class="mt-2 pa-0">
                <v-list-item v-for="(doc, i) in form.documents" :key="'edoc-'+i" class="px-0">
                  <v-list-item-icon class="mr-2"><v-icon small :color="docColor(doc.type)">{{ docIcon(doc.type) }}</v-icon></v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2">{{ doc.name }}</v-list-item-title>
                    <v-list-item-subtitle class="text-caption">{{ doc.type ? doc.type.toUpperCase() : '' }} · {{ formatSize(doc.size) }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon x-small color="error" :loading="deletingDoc === i" @click="deleteExistingDoc(i)"><v-icon x-small>mdi-delete</v-icon></v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <!-- New documents to upload -->
              <v-list dense v-if="docFiles.length" class="mt-2 pa-0">
                <v-list-item v-for="(doc, i) in docFiles" :key="'ndoc-'+i" class="px-0">
                  <v-list-item-icon class="mr-2"><v-icon small color="primary">mdi-file-upload</v-icon></v-list-item-icon>
                  <v-list-item-content><v-list-item-title class="text-body-2">{{ doc.name }} <v-chip x-small color="success" class="ml-1">New</v-chip></v-list-item-title></v-list-item-content>
                  <v-list-item-action><v-btn icon x-small color="error" @click="removeDoc(i)"><v-icon x-small>mdi-close</v-icon></v-btn></v-list-item-action>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col sm="4" class="d-flex align-center">
              <v-switch
                v-model="form.is_active"
                :true-value="1"
                :false-value="0"
                label="Active"
                color="primary"
                inset
                hide-details
                class="mt-0 pt-0"
              ></v-switch>
            </v-col>
            <v-col sm="12">
              <v-textarea
                outlined
                v-model="form.description"
                label="Product Description"
              ></v-textarea>
            </v-col>
          </v-row>

          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Update product
          </v-btn>
        </v-card-text>
      </v-card>
      <!-- Snackbar -->
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" :timeout="3000" top right>
        {{ snackbar.message }}
        <template v-slot:action="{ attrs }">
          <v-btn color="white" text v-bind="attrs" @click="snackbar.show = false">Close</v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "ProductCreatePage",
  data() {
    return {
      form: {
        product_type_id: "",
        product_name: "",
        description: "",
        end_tenure: "",
        pre_tax_irr: "",
        minimum_invest: "",
        maximum_invest: "",
        amount_raised: "",
        settlememt_date: "",
        risk_category: "",
        payout_frequency: "",
        category_ids: [],
        is_active: 1,
      },
      image_url: null,
      imageFile: null,
      isLoading: false,
      menu: false,

      errors: {},
      productTypeItems: [],
      categoryItems: [],
      riskCategoryItems: [
        { id: 1, text: "Low", value: 1 },
        { id: 2, text: "Medium", value: 2 },
        { id: 3, text: "High", value: 3 },
      ],
      imageFiles: [],
      previewImages: [],
      docFiles: [],
      deletingDoc: null,
      mediaUrl: "https://blr1.vultrobjects.com/space-1/",
      snackbar: { show: false, message: "", color: "success" },
    };
  },
  mounted() {
    this.getMasters();
    this.getData();
  },

  methods: {
    

  async getData() {
  this.isLoading = true;
  let encryptedId = this.$route.params.productsId;

  try {
    const response = await axios.get(`/products/${encryptedId}`);
    this.form = response.data.data;
    this.old_json = response.data.data;
    if (!this.form.payout_frequency) {
      this.form.payout_frequency = "monthly";
    }
    const mediaUrl = "https://blr1.vultrobjects.com/space-1/";
    if (this.form.image_path) {
      this.image_url = mediaUrl + this.form.image_path; // adjust key based on your actual API response
    }
    console.log(this.form);
    
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    this.isLoading = false;
  }
},


   async getMasters() {
      try {
        const { data } = await axios.get("masters?context=product_type");

        this.productTypeItems = data.product_type.map((type) => ({
          id: type.id,
          text: type.name,
          value: type.id,
        }));
        const categoriesResponse = await axios.get("masters?context=category");
        this.categoryItems = categoriesResponse.data.category.map(
          (category) => ({
            text: category.name,
            value: category.id,
          })
        );
      } catch (error) {
        console.error(error);
      }
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.imageFile = file;
        this.image_url = URL.createObjectURL(file);
      }
    },

    removeImage() {
      this.imageFile = null;
      this.image_url = null;
      this.$refs.file.value = null;
    },

    onImagesChange(e) {
      const files = Array.from(e.target.files);
      files.forEach(file => {
        this.imageFiles.push(file);
        this.previewImages.push(URL.createObjectURL(file));
      });
      this.$refs.imagesInput.value = null;
    },

    removePreviewImage(index) {
      this.imageFiles.splice(index, 1);
      this.previewImages.splice(index, 1);
    },

    onDocsChange(e) {
      Array.from(e.target.files).forEach(f => this.docFiles.push(f));
      this.$refs.docsInput.value = null;
    },

    removeDoc(index) {
      this.docFiles.splice(index, 1);
    },

    async deleteExistingDoc(index) {
      this.deletingDoc = index;
      const productsId = this.$route.params.productsId;
      try {
        const res = await axios.delete(`products/${productsId}/documents/${index}`);
        this.form.documents = res.data.data.documents;
      } catch (error) {
        console.error("Delete doc failed:", error);
      } finally {
        this.deletingDoc = null;
      }
    },

    formatSize(bytes) {
      if (!bytes) return '';
      if (bytes < 1024) return bytes + ' B';
      if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
      return (bytes / 1048576).toFixed(1) + ' MB';
    },

    docIcon(type) {
      if (!type) return 'mdi-file';
      const t = type.toLowerCase();
      if (t === 'pdf') return 'mdi-file-pdf-box';
      if (['doc', 'docx'].includes(t)) return 'mdi-file-word-box';
      if (['xls', 'xlsx'].includes(t)) return 'mdi-file-excel-box';
      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(t)) return 'mdi-file-image';
      return 'mdi-file-document';
    },

    docColor(type) {
      if (!type) return 'grey';
      const t = type.toLowerCase();
      if (t === 'pdf') return 'red darken-1';
      if (['doc', 'docx'].includes(t)) return 'blue darken-1';
      if (['xls', 'xlsx'].includes(t)) return 'green darken-1';
      if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(t)) return 'purple';
      return 'grey darken-1';
    },

    async save() {
      try {
        this.isLoading = true;
        const productsId = this.$route.params.productsId;

        const response = await axios.patch(`products/${productsId}`, this.form);

        const savedProduct = response.data.data;
        await this.handlefileuploads(savedProduct.id);

        this.snackbar = { show: true, message: "Product updated successfully!", color: "success" };
        setTimeout(() => this.$router.push("/products"), 1500);
      } catch (e) {
        console.log(e);
        this.snackbar = { show: true, message: "Failed to update product. Please try again.", color: "error" };
        this.isLoading = false;
      }
    },

    async handlefileuploads(productId) {
      if (this.imageFiles.length > 0) {
        const formData = new FormData();
        formData.append("id", productId);
        this.imageFiles.forEach(file => formData.append("images[]", file));
        try {
          await axios.post("products/upload_images", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        } catch (error) {
          console.error("Image upload failed:", error);
        }
      }
      if (this.docFiles.length > 0) {
        const formData = new FormData();
        formData.append("id", productId);
        this.docFiles.forEach(f => formData.append("documents[]", f));
        try {
          await axios.post("products/upload_documents", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });
        } catch (error) {
          console.error("Document upload failed:", error);
        }
      }
    },
  },
};
</script>
